import React, { useEffect, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import productAPI from "../../api/productApi";
import ProductCard from "./Card";

function ListPage() {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);

    try {
      const res = await productAPI.listing();

      if (res.code === 200) {
        const { products, totalCount } = res.data;

        setItems(products);
        setTotalCount(totalCount);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrump title="Shop" />

      <section className="s-term-user flat-spacing-25">
        <div className="container">
          <div className="blog-count text-left mb-4">
            Total: <b>{totalCount}</b> categories
          </div>

          {items && items.length > 0 && (
            <div className="row  g-4">
              {items.map((item, index) => (
                <div className="col-md-3" key={index}>
                  <ProductCard item={item} />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default ListPage;
